// extracted by mini-css-extract-plugin
export var border = "MissionStatementBlockSquare-module--border--209d8";
export var bordercontainer = "MissionStatementBlockSquare-module--bordercontainer--cd477";
export var buttonwrapper = "MissionStatementBlockSquare-module--buttonwrapper--de6a5";
export var details = "MissionStatementBlockSquare-module--details--443c7";
export var image = "MissionStatementBlockSquare-module--image--75860";
export var leftheart = "MissionStatementBlockSquare-module--leftheart--65427";
export var middleheart = "MissionStatementBlockSquare-module--middleheart--cf8c6";
export var missionstatementblockcontainer = "MissionStatementBlockSquare-module--missionstatementblockcontainer--d5af7";
export var rightheart = "MissionStatementBlockSquare-module--rightheart--69a98";
export var subheading = "MissionStatementBlockSquare-module--subheading--25f29";
export var text = "MissionStatementBlockSquare-module--text--f3848";
export var title = "MissionStatementBlockSquare-module--title--4730f";